module.exports = __webpack_public_path__ + "media/images/brand/lander/right-iceberg-a3964069f3f6f04b17e071d0996b20eb.png";